"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconService = function SvgIconService(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "service icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Service Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 6c.587 0 1.069.45 1.12 1.023l.005.102v.497a.75.75 0 00.66.75 15.021 15.021 0 0113.053 12.736.75.75 0 00.664.638l.086.004h1.287a1.125 1.125 0 01.102 2.245l-.102.005H14.757c.053.004.106.01.159.018 1.786.202 3.874 2.198 5.75 5.487l.152.27c.139.28.39.49.69.576.615.1 1.245-.038 1.762-.387a25.705 25.705 0 003.195-2.458 15.15 15.15 0 014.893-3.287c2.265-.593 3.666.152 4.21 1l.051.083a1.431 1.431 0 01-.045 1.665l-.078.095-11.7 11.88a.75.75 0 01-.838.158l-.083-.043-7.409-4.463a.75.75 0 01-.361-.673c.082-1.994-.105-5.442-2.027-7.591a1.242 1.242 0 010-1.661c.36-.395.854-.63 1.375-.669H7.125a1.125 1.125 0 01-.102-2.245l.102-.005H8.4a.75.75 0 00.75-.642A15.02 15.02 0 0122.215 8.376a.75.75 0 00.656-.663l.004-.087v-.501C22.875 6.504 23.379 6 24 6zm.24 6.259a1.125 1.125 0 00-1.333-.859 13.173 13.173 0 00-7.273 4.435 1.125 1.125 0 101.732 1.439 10.904 10.904 0 015.741-3.614l.283-.067c.603-.132.983-.73.85-1.334zM14.13 36.254a.75.75 0 01.866-.184l.079.041 6.546 3.939a.768.768 0 01.351.514.75.75 0 01-.099.525l-.053.075-.442.554a.75.75 0 01-.49.276l-.097.006H10.664a.75.75 0 01-.62-1.17l.06-.076 4.026-4.5z"
  }));
};

var _default = SvgIconService;
exports.default = _default;